import React, { useState, useContext } from "react";
import { WithChildren } from '../../../_metronic/helpers/react18MigrationHelpers';


type CubeOption = {
    value: string
    label: string
}

type GlobalContextInterface = {
    bu: string,
    setBU: React.Dispatch<React.SetStateAction<string>>,
    loaderMessage: string,
    setLoaderMessage: React.Dispatch<React.SetStateAction<string>>,
    chatNSRVisible: boolean,
    setChatNSRVisible: React.Dispatch<React.SetStateAction<boolean>>,
    chatNSRSettings: {},
    setChatNSRSettings: React.Dispatch<React.SetStateAction<{}>>,
    lensCubeOptions: CubeOption[],
    setLensCubeOptions: React.Dispatch<React.SetStateAction<CubeOption[]>>,
}
const GlobalContext = React.createContext<GlobalContextInterface>({
    bu: "default",
    setBU: () => { },
    loaderMessage: "",
    setLoaderMessage: () => { },
    chatNSRVisible: false,
    setChatNSRVisible: () => { },
    chatNSRSettings: {},
    setChatNSRSettings: () => { },
    lensCubeOptions: [],
    setLensCubeOptions: () => { },
});

export function useGlobalContext() {
    return useContext(GlobalContext);
}

export const GlobalContextProvider: React.FC<WithChildren> = (props) => {
    const [bu, setBU] = useState<string>("default")
    const [loaderMessage, setLoaderMessage] = useState<string>("")
    const [chatNSRVisible, setChatNSRVisible] = useState<boolean>(false)
    const [chatNSRSettings, setChatNSRSettings] = useState<{}>({});
    const [lensCubeOptions, setLensCubeOptions] = useState<CubeOption[]>([]);

    return <GlobalContext.Provider
        value={{
            bu,
            setBU,
            loaderMessage,
            setLoaderMessage,
            chatNSRVisible,
            setChatNSRVisible,
            chatNSRSettings,
            setChatNSRSettings,
            lensCubeOptions,
            setLensCubeOptions
        }}>
        {props.children}
    </GlobalContext.Provider>
}

export default GlobalContext;